import { baseService } from 'services';
import { ReliantResponse } from 'interface/apiInterface';
import { listStagesEP, getStageEP } from 'services/constants';
import {
  IListStageRequest,
  IListStageResponse,
  IGetStageRequest,
  IGetStageResponse,
} from 'interface/stageInterface';
import { AxiosError } from 'axios';

export const listStages = async (
  data: IListStageRequest,
): Promise<ReliantResponse<IListStageResponse>> => {
  try {
    const response = await baseService.post<IListStageResponse>(
      listStagesEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const getStage = async (
  data: IGetStageRequest,
): Promise<ReliantResponse<IGetStageResponse>> => {
  try {
    const response = await baseService.post<IGetStageResponse>(
      getStageEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};
